import { render } from "./HeaderPage.vue?vue&type=template&id=40522ed2&scoped=true"
import script from "./HeaderPage.vue?vue&type=script&lang=js"
export * from "./HeaderPage.vue?vue&type=script&lang=js"

import "./HeaderPage.vue?vue&type=style&index=0&id=40522ed2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-40522ed2"

export default script